// extracted by mini-css-extract-plugin
module.exports = {"documents":"Documents_documents__26DF1","Tabs":"Documents_Tabs__2olEw"};